import Vue from "vue";
Vue.prototype.$bus = new Vue();
const EVENTS = {
  updateTitlePatient: "titlebar-patient",
  updateDateFormat: "titlebar-dateformat",
  showGlobalWatting: "show-global-watting",
  hideGlobalWatting: "hide-global-watting",
  loadMorePatients: "load-more-patients",
  refreshPatients: "refresh-patients",
  refreshRecords: "refresh-records",
  showCapture: "show-capture",
  updateRecord: "update-record",
  reanalyzeMeibomian: "reanalyze-Meibomian",
  reshowCapture: "dryeye-reshow-capture",
  updateData: "update-data",
  ctCallback: "ct-callback",
  octCallback: "oct-callback",
  spreadKeyBoard: "spread-keyBoard", // 唤起软键盘,
  eyeTypeShot: "eye-type-shot",
  dicomStart: "dicom-start",
  setLang: "set-lang",
  setDateFrom: "set-dateFrom",
  setLogin: "set-login",
  setDicom: "set-dicom",
  setTopo: "set-topo",
  setPrint: "set-print",
  setStorage: "set-storage",
  setLipid: "set-Lipid",
  setShowPupilEdge: "set-ShowPupilEdge",
  hideScreenSaver: "hide-screen-saver",
  uploading2server: "uploading-2-server",
  lapidlayerVideoTime: "lapidlayer-video-time",
  uploadingThirdyParty: "uploading-thirdparty",
  fbutVideoTime: "fbut-video-time",
  dryeyeUpDown: "dryeye-up-down",
  canLogout: "can-logout",
  showSettings: "show-settings",
  showOPI: "show-opi",
  changeEyeMaterial: "change-eye-material"
};
export default EVENTS;



// WEBPACK FOOTER //
// ./src/bus/index.js